export default __webpack_public_path__ + "static/media/multimedia.ae425674.jpg";